<template>
    <div class="row system-alerts">
        <div class="col">
            <template v-if="data.length > 0">
                <button v-for="entry in data" class="c-btn c-btn--warning" v-on:click="showAlert(entry)">
                    <fa :icon="['far', 'info-square']"></fa>
                    {{ entry.short_notice }}
                </button>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Modal from "@/components/system-alerts/Modal.vue";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState({
            isLoading: (state) => state.platformUpdates.isLoading
        }),
        ...mapGetters({
            data: "platformUpdates/getSystemAlerts",
            hasData: "platformUpdates/hasData",
            isFirstRun: "platformUpdates/isFirstRun"
        })
    },
    methods: {
        showAlert(entry) {
            this.$modal.show(Modal, {
                entry
            });
        }
    },
    mounted() {
        this.$store.commit("platformUpdates/addPlatformUpdateRequest", {
            tag: "server_status",
            callback: "_handleServerStatus"
        });
        this.$store.commit("platformUpdates/addPlatformUpdateRequest", {
            tag: "load_status",
            callback: "_handleLoadStatus"
        });
        this.$store.commit("platformUpdates/addPlatformUpdateRequest", {
            tag: "service_status",
            callback: "_handleServiceStatus"
        });
    }
};
</script>
